import {
	dedup,
	filter,
	asyncmap as map,
	asyncpipe as pipe,
} from "lib/functions";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import axios from "axios";
import { values } from "ramda";

export const useLinesById = (linesIds) => {
	const [lines] = useGlobal("linesv2");
	const [exec, setExec] = useState(false);
	const requestLine = useDispatch("requestLine");

	useEffect(() => {
		if (linesIds.length === 0) return;
		if (exec) return;
		// prevent re-fetches (this is an fugly hack. shoul be replaced with middlewares)
		setExec(true);
		pipe(filter(dedup), map(fetchLineData), map(requestLine))(linesIds);
	}, [linesIds, requestLine, exec]);

	// if any of the lines ids is in isloading arr, then it's still loading
	const { isloading, error } = lines;
	const loading = isloading.some((id) => linesIds.some((id0) => id0 === id));

	return [lines, loading, error];
};

export const useLinesByOfficeSlug = (officeSlug) => {
	const [offices] = useGlobal("officesv2");
	const [lines] = useGlobal("linesv2");
	const office = offices.bySlug[officeSlug];

	const loading = offices.loading;

	if (!office || !office.lines || !lines || !lines.bySlug)
		return [true, null];

	if (lines && lines.bySlug) {
		return [
			loading,
			values(lines.bySlug).filter(
				(line) => line.officeSlug === officeSlug
			),
		];
	}
	return [loading, office.lines.map((l) => lines.bySlug[l])];
};

const fetchLineData = (lineId) =>
	axios.get(`https://zeroq.cl/api/v1/lines/${lineId}/info`).then((a) => ({
		lineSlug: a.data.line_slug,
		officeSlug: a.data.office_slug,
		lineId,
	}));

export const useLine = (lineSlug, officeSlug) => {
	const [lines] = useGlobal("linesv2");
	const requestLine = useDispatch("requestLine");

	useEffect(() => {
		requestLine({ officeSlug, lineSlug });
	}, [lineSlug, officeSlug]);

	return [lines.bySlug[lineSlug], lines.loading, lines.error];
};
